import React, { useEffect, useState } from 'react'
import { client, urlFor } from '../client';
import Comment from './Comment';
import { IoIosAdd } from 'react-icons/io';
import ClickAwayListener from 'react-click-away-listener';
import { Link, useParams } from 'react-router-dom';
import { commentQuery } from '../utils/data';
import { v4 as uuidv4 } from 'uuid';

const Comments = ({ user, _detail }) => {
    const [addingComment, setAddingComment] = useState(false);
    const [comment, setComment] = useState('');
    const [detail, setDetail] = useState(_detail);
    const [listenSuccess, setListenSuccess] = useState(false);


    const addComment = () => {
        if (comment) {
            setAddingComment(true);

            client
                .patch(_detail?._id)
                .setIfMissing({ comments: [] })
                .insert('after', 'comments[-1]', [{ comment, _key: uuidv4(), postedBy: { _type: 'postedBy', _ref: user?._id } }])
                .commit()
                .then(() => {
                    // fetchPinDetails();
                    setComment('');
                    setAddingComment(false);
                });
        }
    };

    useEffect(() => {
        const query = '*[_id== $id]';
        const params = { id: _detail._id };
        const subscription = client
            .listen(query, params)
            .subscribe(update => {
                const comment = update.result;
                setDetail(comment);
                setListenSuccess(true);
            })

        return () => {
            subscription.unsubscribe();
        }

    }, [_detail]);


    return (
        <>
            {detail?.comments?.map((item) => (
                <div className="flex gap-2 mt-5 bg-white rounded-lg " key={item._key}>
                    <img
                        src={listenSuccess ? item.commenter?.image : (item.postedBy.profUrl)}
                        className="w-10 h-10 rounded-full cursor-pointer justify-start"
                        alt="user-profile"
                    />
                    <div className="flex flex-col w-full">
                        <div className='flex flex-row'>
                            <p className="font-bold">{listenSuccess ? item.commenter?.userName : item.postedBy.userName}</p>
                            <p className='pl-2 text-xs align-middle'>-{item.timeStamp}</p>
                        </div>
                        <Comment commentText={item.comment} key={item._key} userId={user?._id} />
                        {/* <div className='bg-secondaryColor'>
                            {_detail?.comments?.comments?.map((item) => (
                                <div className="flex gap-2 mt-5 items-center bg-white rounded-lg" key={item.comment}>
                                    <img
                                        src={item.postedBy?.image}
                                        className="w-10 h-10 rounded-full cursor-pointer"
                                        alt="user-profile"
                                    />
                                    <div className="flex flex-col">
                                        <p className="font-bold">{item.postedBy?.userName}</p>
                                        <p>{item.comment}</p>
                                    </div>
                                </div>
                            ))}
                            
                        </div> */}
                    </div>
                </div>
            ))}
        </>
    )
}

export default Comments
